export default "__VITE_PUBLIC_ASSET__0ddb01d8__"